import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pwa-finance" }
const _hoisted_2 = { class: "finance-header" }
const _hoisted_3 = { class: "header-row" }
const _hoisted_4 = { class: "summary-section" }
const _hoisted_5 = { class: "summary-main" }
const _hoisted_6 = { class: "summary-row" }
const _hoisted_7 = { class: "item" }
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "item" }
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "tabs" }
const _hoisted_12 = { class: "finance-list" }
const _hoisted_13 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "info" }
const _hoisted_16 = { class: "name" }
const _hoisted_17 = { class: "category" }
const _hoisted_18 = { class: "sheet-header" }
const _hoisted_19 = {
  key: 0,
  class: "sheet-body"
}
const _hoisted_20 = { class: "detail-row" }
const _hoisted_21 = { class: "value" }
const _hoisted_22 = { class: "detail-row" }
const _hoisted_23 = { class: "value" }
const _hoisted_24 = { class: "detail-row" }
const _hoisted_25 = {
  key: 0,
  class: "detail-row"
}
const _hoisted_26 = { class: "value" }
const _hoisted_27 = { class: "year-picker" }
const _hoisted_28 = { class: "year-list" }
const _hoisted_29 = ["onClick"]

import { ref, computed, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';
import LodingComponent from '@/components/loading/LodingComponent.vue';

interface FinanceItem {
  id: number;
  name: string;
  category: string;
  amount: number;
  note?: string;
  type?: 'revenue' | 'expense';
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PwaFinance',
  setup(__props) {

const store = useStore();
const user = computed(() => store.state.user);

const isLoading = ref(false);
const activeTab = ref<'revenue' | 'expense'>('revenue');
const showDetailSheet = ref(false);
const showYearPicker = ref(false);
const selectedItem = ref<FinanceItem | null>(null);

const currentYear = new Date().getFullYear();
const selectedYear = ref(currentYear);
const availableYears = computed(() => Array.from({ length: 5 }, (_, i) => currentYear - 2 + i));

const revenueItems = ref<FinanceItem[]>([]);
const expenseItems = ref<FinanceItem[]>([]);

const currentList = computed(() => 
  activeTab.value === 'revenue' ? revenueItems.value : expenseItems.value
);

const totalRevenue = computed(() => 
  revenueItems.value.reduce((sum, item) => sum + (item.amount || 0), 0)
);

const totalExpense = computed(() => 
  expenseItems.value.reduce((sum, item) => sum + (item.amount || 0), 0)
);

const budgetBalance = computed(() => totalRevenue.value - totalExpense.value);

const fetchFinanceData = async () => {
  if (!user.value?.m_sisul_code) return;
  try {
    isLoading.value = true;
    const response = await axios.get(`/api/finance/budget/${user.value.m_sisul_code}/${selectedYear.value}`, { withCredentials: true });

    if (response.data.success) {
      revenueItems.value = response.data.data?.revenueItems || [];
      expenseItems.value = response.data.data?.expenseItems || [];
    } else {
      revenueItems.value = [
        { id: 1, name: '급여청구수입', category: '진료수입', amount: 50000000 },
        { id: 2, name: '정부지원금', category: '보조금', amount: 20000000 }
      ];
      expenseItems.value = [
        { id: 1, name: '직원 급여', category: '인건비', amount: 30000000 },
        { id: 2, name: '임대료', category: '임대료', amount: 5000000 },
        { id: 3, name: '운영비', category: '기타비용', amount: 3000000 }
      ];
    }
  } catch (error) {
    console.error('회계 데이터 조회 오류:', error);
    revenueItems.value = [
      { id: 1, name: '급여청구수입', category: '진료수입', amount: 50000000 },
      { id: 2, name: '정부지원금', category: '보조금', amount: 20000000 }
    ];
    expenseItems.value = [
      { id: 1, name: '직원 급여', category: '인건비', amount: 30000000 },
      { id: 2, name: '임대료', category: '임대료', amount: 5000000 },
      { id: 3, name: '운영비', category: '기타비용', amount: 3000000 }
    ];
  } finally {
    isLoading.value = false;
  }
};

const formatCurrency = (value: number) => {
  if (!value) return '0';
  return new Intl.NumberFormat('ko-KR').format(value);
};

const selectYear = (year: number) => {
  selectedYear.value = year;
  showYearPicker.value = false;
  fetchFinanceData();
};

const openItemDetail = (item: FinanceItem) => {
  selectedItem.value = { ...item, type: activeTab.value };
  showDetailSheet.value = true;
};

watch(selectedYear, () => fetchFinanceData());
onMounted(() => fetchFinanceData());

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "page-title" }, "회계", -1)),
        _createElementVNode("button", {
          class: "year-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showYearPicker.value = true))
        }, [
          _createTextVNode(_toDisplayString(selectedYear.value) + "년 ", 1),
          _createVNode(_component_v_icon, { size: "16" }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("mdi-chevron-down", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "label" }, "예산 잔액", -1)),
        _createElementVNode("span", {
          class: _normalizeClass(["value", { red: budgetBalance.value < 0 }])
        }, _toDisplayString(budgetBalance.value >= 0 ? '' : '-') + _toDisplayString(formatCurrency(Math.abs(budgetBalance.value))) + "원 ", 3)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[9] || (_cache[9] = _createElementVNode("span", { class: "dot green" }, null, -1)),
          _cache[10] || (_cache[10] = _createElementVNode("span", { class: "label" }, "세입", -1)),
          _createElementVNode("span", _hoisted_8, _toDisplayString(formatCurrency(totalRevenue.value)), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[11] || (_cache[11] = _createElementVNode("span", { class: "dot red" }, null, -1)),
          _cache[12] || (_cache[12] = _createElementVNode("span", { class: "label" }, "세출", -1)),
          _createElementVNode("span", _hoisted_10, _toDisplayString(formatCurrency(totalExpense.value)), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", {
        class: _normalizeClass({ active: activeTab.value === 'revenue' }),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = 'revenue'))
      }, "세입", 2),
      _createElementVNode("button", {
        class: _normalizeClass({ active: activeTab.value === 'expense' }),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (activeTab.value = 'expense'))
      }, "세출", 2)
    ]),
    _createElementVNode("div", _hoisted_12, [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(5, (n) => {
            return _createElementVNode("div", {
              key: n,
              class: "finance-item skeleton"
            }, [...(_cache[13] || (_cache[13] = [
              _createElementVNode("div", { class: "skeleton-icon" }, null, -1),
              _createElementVNode("div", { class: "skeleton-text" }, null, -1),
              _createElementVNode("div", { class: "skeleton-amount" }, null, -1)
            ]))])
          }), 64))
        : (currentList.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_component_v_icon, {
                size: "40",
                color: "#d1d5db"
              }, {
                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                  _createTextVNode("mdi-currency-krw", -1)
                ]))]),
                _: 1
              }),
              _cache[15] || (_cache[15] = _createElementVNode("span", null, "항목이 없습니다", -1))
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "finance-item",
                  onClick: ($event: any) => (openItemDetail(item))
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["icon", activeTab.value])
                  }, [
                    _createVNode(_component_v_icon, {
                      size: "16",
                      color: "white"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(activeTab.value === 'revenue' ? 'mdi-arrow-down' : 'mdi-arrow-up'), 1)
                      ]),
                      _: 1
                    })
                  ], 2),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(item.name), 1),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(item.category), 1)
                  ]),
                  _createElementVNode("span", {
                    class: _normalizeClass(["amount", activeTab.value])
                  }, _toDisplayString(activeTab.value === 'revenue' ? '+' : '-') + _toDisplayString(formatCurrency(item.amount)), 3)
                ], 8, _hoisted_14))
              }), 128)),
              _createElementVNode("div", {
                class: _normalizeClass(["total-row", activeTab.value])
              }, [
                _createElementVNode("span", null, _toDisplayString(activeTab.value === 'revenue' ? '세입' : '세출') + " 합계", 1),
                _createElementVNode("span", null, _toDisplayString(formatCurrency(activeTab.value === 'revenue' ? totalRevenue.value : totalExpense.value)) + "원", 1)
              ], 2)
            ], 64))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["sheet-overlay", { open: showDetailSheet.value }]),
      onClick: _cache[3] || (_cache[3] = ($event: any) => (showDetailSheet.value = false))
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["sheet", { open: showDetailSheet.value }])
    }, [
      _cache[22] || (_cache[22] = _createElementVNode("div", { class: "sheet-handle" }, null, -1)),
      _createElementVNode("div", _hoisted_18, [
        _cache[17] || (_cache[17] = _createElementVNode("span", null, "항목 상세", -1)),
        _createElementVNode("button", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (showDetailSheet.value = false))
        }, [
          _createVNode(_component_v_icon, { size: "20" }, {
            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
              _createTextVNode("mdi-close", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      (selectedItem.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _cache[18] || (_cache[18] = _createElementVNode("span", { class: "label" }, "항목명", -1)),
              _createElementVNode("span", _hoisted_21, _toDisplayString(selectedItem.value.name), 1)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _cache[19] || (_cache[19] = _createElementVNode("span", { class: "label" }, "분류", -1)),
              _createElementVNode("span", _hoisted_23, _toDisplayString(selectedItem.value.category), 1)
            ]),
            _createElementVNode("div", _hoisted_24, [
              _cache[20] || (_cache[20] = _createElementVNode("span", { class: "label" }, "금액", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["value", selectedItem.value.type === 'revenue' ? 'green' : 'red'])
              }, _toDisplayString(formatCurrency(selectedItem.value.amount)) + "원 ", 3)
            ]),
            (selectedItem.value.note)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _cache[21] || (_cache[21] = _createElementVNode("span", { class: "label" }, "비고", -1)),
                  _createElementVNode("span", _hoisted_26, _toDisplayString(selectedItem.value.note), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_v_dialog, {
      modelValue: showYearPicker.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showYearPicker).value = $event)),
      "max-width": "280"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { rounded: "lg" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_27, [
              _cache[24] || (_cache[24] = _createElementVNode("div", { class: "picker-title" }, "연도 선택", -1)),
              _createElementVNode("div", _hoisted_28, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableYears.value, (year) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: year,
                    class: _normalizeClass({ active: selectedYear.value === year }),
                    onClick: ($event: any) => (selectYear(year))
                  }, [
                    _createTextVNode(_toDisplayString(year) + "년 ", 1),
                    (selectedYear.value === year)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          size: "18"
                        }, {
                          default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                            _createTextVNode("mdi-check", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_29))
                }), 128))
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(LodingComponent, {
      "is-visible": isLoading.value,
      text: "회계 정보를 불러오는 중..."
    }, null, 8, ["is-visible"])
  ]))
}
}

})